import { useEffect, useRef } from 'react';

interface Segmento {
  label: string;
  valor: number;
  cor: string;
}
interface Props {
  segmentos: Segmento[];
  size?: number;
}

export function StatusDonut({ segmentos, size = 160 }: Props) {
  const refs = useRef<(SVGCircleElement | null)[]>([]);
  useEffect(() => {
    refs.current.forEach((c, i) => {
      if (!c) return;
      const target = c.getAttribute('data-dash-target') || '0';
      c.style.transition = 'none';
      c.style.strokeDasharray = `0 ${10000}`;
      c.getBoundingClientRect();
      c.style.transition = `stroke-dasharray 700ms cubic-bezier(0.16, 1, 0.3, 1) ${i * 120}ms`;
      c.style.strokeDasharray = target;
    });
  }, [segmentos]);

  const total = segmentos.reduce((s, x) => s + x.valor, 0);
  const r = size / 2 - 14;
  const c = 2 * Math.PI * r;
  let acumulado = 0;

  return (
    <div className="flex items-center gap-s7">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="shrink-0">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="var(--bg-card)"
          strokeWidth={14}
        />
        {segmentos.map((seg, i) => {
          const frac = total > 0 ? seg.valor / total : 0;
          const dash = frac * c;
          const offset = -acumulado;
          acumulado += dash;
          return (
            <circle
              key={i}
              ref={(el) => { refs.current[i] = el; }}
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke={seg.cor}
              strokeWidth={14}
              data-dash-target={`${dash} ${c - dash}`}
              strokeDasharray={`${dash} ${c - dash}`}
              strokeDashoffset={offset}
              transform={`rotate(-90 ${size / 2} ${size / 2})`}
              strokeLinecap="butt"
            />
          );
        })}
        <text
          x={size / 2}
          y={size / 2 + 8}
          textAnchor="middle"
          fontFamily="var(--font-mono)"
          fontSize={26}
          fontWeight={500}
          fill="var(--fg-1)"
          className="tnum"
        >
          {total}
        </text>
      </svg>
      <ul className="flex flex-col gap-s3 flex-1">
        {segmentos.map((s, i) => (
          <li key={i} className="flex items-center gap-s3">
            <span className="w-[10px] h-[10px] rounded-full" style={{ background: s.cor }} />
            <span className="font-body text-[12.5px] text-fg-2 flex-1">{s.label}</span>
            <span className="font-mono text-[12px] text-fg-1 tnum">{s.valor}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default StatusDonut;
